export enum IMenu {
  HOME = 0,
  SHOP = 1,
  ACCOUNT = 2,
}
